import React from "react";
import "normalize.css";
import "./index.css";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import Rutas from "./routes/routes.js";
import { SearchProvider } from "./context/SearchContext";
import ScrollToTop from "./components/ScrollToTop";

ReactDOM.render(
  <React.StrictMode>
    <SearchProvider>
      <Rutas />
    </SearchProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
